import { atom } from 'recoil';
import { UserRoutesAtom } from '@types';

export const userRoutes = atom<UserRoutesAtom>({
  key: 'userTabs',
  default: { routes: undefined, menu: undefined, refetch: () => {} }
});
